import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { Button, Alert } from 'antd';
import { AuthLayout } from 'COMPONENTS/Layout';
import IMGLogo from 'ASSETS/newsroom-logo.svg';
import { signIn } from 'ACTIONS/auth.actions';
import './AuthSignInPage.less';

const AuthSignInPage = (props) => {
  const { signIn: signInAction, isAuthLoading } = props;
  return (
    <AuthLayout>
      <div className="signin-content">
        {props.isAccountInvalid && (
          <Alert className="alert-fixed-top" message={props.intl.formatMessage({ id: 'auth.signin.errors.account' })} type="error" />
        )}
        <IMGLogo width="200" height="60" className="logo" />
        <p className="subtitle">{props.intl.formatMessage({ id: 'auth.signin.subtitle' })}</p>
        <Button type="primary" size="large" icon="google" className="signin-button" loading={isAuthLoading} onClick={signInAction}>
          Sign in with Google
        </Button>
      </div>
    </AuthLayout>
  );
};

AuthSignInPage.defaultProps = {
  isAuthLoading: false,
  isAccountInvalid: false,
};

AuthSignInPage.propTypes = {
  signIn: PropTypes.func.isRequired,
  isAuthLoading: PropTypes.bool,
  isAccountInvalid: PropTypes.bool,
  intl: PropTypes.object.isRequired,
};

const mapStateToProps = ({ auth }) => auth;

const enhanced = compose(connect(mapStateToProps, { signIn }), injectIntl);

export { AuthSignInPage as PureAuthSignInPage };
export default enhanced(AuthSignInPage);



// WEBPACK FOOTER //
// ./src/pages/Auth/SignIn/AuthSignInPage.js